import styles from './pushApiEndpointCellRenderer.module.scss';

export const PushApiEndpointCellRenderer = ({ data }) => {
    return (
        <div className={styles['scroll']}>
            <ul className={styles['dashed']}>
                {data?.endpoints?.map((endpoint, index) => (
                    <li key={index}>{endpoint}</li>
                ))}
            </ul>
        </div>
    );
};
